import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';

export function AdminOfflineStoreAdd() {
  const [nameText, setNameText] = useState<string>('');
  const [telText, setTelText] = useState<string>('');
  const [addressText, setAddressText] = useState<string>('');
  const [districtText, setDistrictText] = useState<string>('서울지역');

  const dispatch = useDispatch();
  const history = useHistory();

  const param = {
    name: nameText,
    tel: telText,
    address: addressText,
    district: districtText,
  };

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  // 오프라인 서점 등록하기
  const onClickSave = async () => {
    if (nameText.length <= 0) {
      dispatch(toast.error({ message: '서점명을 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    await server
      .postOfflineStore(param)
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          dispatch(toast.info({ message: '정상적으로 저장되었습니다.' }));
        }
        history.push('/admin/store/offline');
        return payload;
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // AdminOfflineStoreAdd 리턴값
  return (
    <main className="list wrapper">
      <div className="title">
        <h1>오프라인 서점 등록하기</h1>
        <div className="buttons">
          <button type="button" onClick={() => onClickSave()}>
            등록
          </button>
        </div>
      </div>
      <div className="content">
        <ul className="inputs">
          <li className="flex-20 required">
            <span className="required">서점명</span>
            <input
              type="text"
              value={nameText}
              onChange={(event) => {
                setNameText(event.target.value);
              }}
            />
          </li>
          <li className="flex-20">
            <span>전화번호</span>
            <input
              type="text"
              value={telText}
              onChange={(event) => {
                setTelText(event.target.value);
              }}
            />
          </li>
          <li className="flex-20">
            <span>지역</span>
            <div className="selectbox">
              <select
                name=""
                id=""
                defaultValue={districtText}
                onChange={(event) => {
                  setDistrictText(event.target.value);
                }}
              >
                <option value="서울지역">서울지역</option>
                <option value="경기지역">경기지역</option>
                <option value="충청지역">충청지역</option>
                <option value="강원지역">강원지역</option>
                <option value="영남지역">영남지역</option>
                <option value="호남지역">호남지역</option>
                <option value="제주지역">제주지역</option>
              </select>
            </div>
          </li>
          <li className="flex-20">
            <span>주소</span>
            <input
              className="full"
              type="text"
              value={addressText}
              onChange={(event) => {
                setAddressText(event.target.value);
              }}
            />
          </li>
        </ul>
      </div>
    </main>
  );
}
